export function subscribe(ids) {
    return {
        type: 'PARTICIPANTS_SUBSCRIBE',
        ids: Array.isArray(ids) ? ids : [ ids ]
    };
}

export function unsubscribe(ids) {
    return {
        type: 'PARTICIPANTS_UNSUBSCRIBE',
        ids: Array.isArray(ids) ? ids : [ ids ]
    };
}
